if (!customElements.get("m-collection-list")) {
  class e extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      (this.selectors = {
        slideControls: ".m-slider-controls",
        slideContainer: ".m-mixed-layout__wrapper",
      }),
        (this.domNodes = queryDomNodes(this.selectors, this)),
        (this.enableSlider = "true" === this.dataset.enableSlider),
        (this.items = this.dataset.items),
        (this.total = this.dataset.total),
        (this.autoplay = "true" === this.dataset.autoplay),
        (this.autoplaySpeed = this.dataset.autoplaySpeed),
        (this.paginationType = this.dataset.paginationType),
        (this.expanded = "true" === this.dataset.expanded),
        (this.mobileDisableSlider =
          "true" === this.dataset.mobileDisableSlider),
        this.initByScreenSize(),
        document.addEventListener("matchMobile", () => {
          this.initByScreenSize();
        }),
        document.addEventListener("unmatchMobile", () => {
          this.initByScreenSize();
        });
    }
    initByScreenSize() {
      if (!this.enableSlider) return;
      const { slideContainer: e, slideControls: t } = queryDomNodes(
        this.selectors,
        this
      );
      MinimogTheme.config.mqlMobile && this.mobileDisableSlider
        ? (t?.classList.add("m:hidden"),
          e.classList.remove("swiper-container"),
          this.swiper && this.swiper.destroy(!1, !0))
        : (t?.classList.remove("m:hidden"), this.initSlider());
    }
    initSlider() {
      const { slideContainer: e } = queryDomNodes(this.selectors, this);
      e?.classList.add("swiper-container");
      this.slider = new MinimogLibs.Swiper(e, {
        slidesPerView: 2,
        loop: !0,
        slidesPerGroup: 1,
        showNavigation: !0,
        showPagination: !0,
        parallax: !0,
        autoplay: !!this.autoplay && {
          delay: 1e3 * parseInt(this.autoplaySpeed),
        },
        pagination:
          "fraction" == this.paginationType
            ? {
                el: this.querySelector(".swiper-pagination"),
                clickable: !0,
                type: "fraction",
              }
            : {
                el: this.querySelector(".swiper-pagination"),
                clickable: !0,
                bulletClass: "m-dot",
                bulletActiveClass: "m-dot--active",
                renderBullet: function (e, t) {
                  return (
                    '<span class="' +
                    t +
                    '"><svg width="65px" height="65px" viewBox="0 0 72 72" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><circle class="time" stroke-width="5" fill="none" stroke-linecap="round" cx="33" cy="33" r="28"></circle></svg></span>'
                  );
                },
              },
        autoHeight: !0,
        breakpoints: {
          480: { slidesPerView: 3 },
          768: {
            slidesPerView: parseInt(this.items) >= 3 ? 3 : parseInt(this.items),
          },
          1280: {
            slidesPerView:
              this.expanded && this.total > this.items
                ? parseInt(this.items) + 1
                : parseInt(this.items),
          },
        },
        on: {
          init() {
            setTimeout(() => {
              window.dispatchEvent(new Event("resize"));
            }, 100);
          },
        },
      });
      const t = this.querySelector(".m-slider-controls"),
        i = t && t.querySelector(".m-slider-controls__button-prev"),
        s = t && t.querySelector(".m-slider-controls__button-next");
      this.slider &&
        i &&
        s &&
        (i && i.addEventListener("click", () => this.slider.slidePrev()),
        s && s.addEventListener("click", () => this.slider.slideNext())),
        (this.swiper = e?.swiper);
    }
  }
  customElements.define("m-collection-list", e);
}

(() => {
  const styleId = 'ra-product-collection-nav-style';

  const ensureStyles = () => {
    if (document.getElementById(styleId)) return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      .template-product .m-collection-list {
        position: relative !important;
      }

      .template-product .m-collection-list .m-mixed-layout__inner {
        gap: 10px !important;
        padding: 2px 46px 8px !important;
      }

      .template-product .m-collection-list .m-collection-card__link {
        min-height: 46px !important;
        padding: 10px 22px !important;
        border-radius: 10px !important;
        font-size: 16px !important;
      }

      .template-product .ra-collection-nav-arrow {
        position: absolute;
        z-index: 5;
        top: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 34px;
        height: 34px;
        padding: 0;
        border: 1px solid #dedede;
        border-radius: 50%;
        background: rgba(255,255,255,.96);
        color: #111;
        box-shadow: 0 2px 8px rgba(0,0,0,.10);
        cursor: pointer;
        transform: translateY(-50%);
        transition: opacity .2s ease, background .2s ease, color .2s ease;
      }

      .template-product .ra-collection-nav-arrow--prev { left: 8px; }
      .template-product .ra-collection-nav-arrow--next { right: 8px; }

      .template-product .ra-collection-nav-arrow:hover {
        border-color: #000;
        background: #000;
        color: #fff;
      }

      .template-product .ra-collection-nav-arrow[disabled] {
        opacity: .35;
        cursor: default;
      }

      .template-product .ra-collection-nav-arrow[disabled]:hover {
        border-color: #dedede;
        background: rgba(255,255,255,.96);
        color: #111;
      }

      .template-product .ra-collection-nav-arrow svg {
        width: 14px;
        height: 14px;
        pointer-events: none;
      }

      @media screen and (max-width: 767px) {
        .template-product .m-collection-list .m-mixed-layout__inner {
          gap: 8px !important;
          padding: 2px 40px 7px !important;
        }

        .template-product .m-collection-list .m-collection-card__link {
          min-height: 40px !important;
          padding: 8px 16px !important;
          border-radius: 9px !important;
          font-size: 14px !important;
        }

        .template-product .ra-collection-nav-arrow {
          width: 30px;
          height: 30px;
        }

        .template-product .ra-collection-nav-arrow--prev { left: 5px; }
        .template-product .ra-collection-nav-arrow--next { right: 5px; }
      }
    `;
    document.head.appendChild(style);
  };

  const arrowSvg = (direction) => direction === 'prev'
    ? '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12.8 3.8 6.6 10l6.2 6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    : '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m7.2 3.8 6.2 6.2-6.2 6.2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const mountNavigation = (section) => {
    if (!document.body.classList.contains('template-product')) return;
    if (section.dataset.raCollectionNavMounted === 'true') return;

    const scroller = section.querySelector('.m-mixed-layout__wrapper');
    if (!scroller) return;

    section.dataset.raCollectionNavMounted = 'true';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'ra-collection-nav-arrow ra-collection-nav-arrow--prev';
    prev.setAttribute('aria-label', 'Scorri le collezioni verso sinistra');
    prev.innerHTML = arrowSvg('prev');

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'ra-collection-nav-arrow ra-collection-nav-arrow--next';
    next.setAttribute('aria-label', 'Scorri le collezioni verso destra');
    next.innerHTML = arrowSvg('next');

    section.append(prev, next);

    const updateButtons = () => {
      const maxScroll = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= maxScroll - 2;
      const hasOverflow = maxScroll > 4;
      prev.hidden = !hasOverflow;
      next.hidden = !hasOverflow;
    };

    const scrollAmount = () => Math.max(180, Math.round(scroller.clientWidth * .72));
    prev.addEventListener('click', () => scroller.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    next.addEventListener('click', () => scroller.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
    window.setTimeout(updateButtons, 250);
  };

  const start = (root = document) => {
    ensureStyles();
    const sections = root.matches?.('.m-collection-list')
      ? [root]
      : root.querySelectorAll?.('.template-product .m-collection-list') || [];
    sections.forEach(mountNavigation);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => start(), { once: true });
  } else {
    start();
  }
  window.addEventListener('load', () => start());
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
